import { motion } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import CloseIcon from "../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../components/NavbarV3/NavbarV3.tsx";
import TabelaV2 from "../../components/TabelaV2/TabelaV2";
import ToastErro from "../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useNomeTabela } from "../../contexts/NomeTabela.tsx";
import { useProfile } from "../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController";
import TabelaRedux from "../../contexts/Tabela";
import MotionSemAutorizacao from "../../core/components/MotionSemAutorizacao.tsx";
import { AvisosModel } from "../../models/AvisosModel";
import {
	cadastraAvisos,
	deleteAvisosPorId,
	editaAvisosPorId,
	getAvisos,
	getAvisosPorId,
} from "../../services/ModuloGerenciador/Avisos";
import "./Avisos.css";

function Avisos(props) {
	const { profile, hasRegra } = useProfile();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useNomeTabela();

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState(new AvisosModel({}));

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarAvisos = useCallback(async () => {
		setLoading(true);
		if (profile?.token) {
			await getAvisos(profile?.token)
				.then((result) => {
					setDadosTabela(result.data);
					setTabelaRedux({});
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				});
		}
		setLoading(false);
	}, []);

	const cadastrar = async () => {
		if (values.nome !== "" && validator.mensagem === "true") {
			setLoading(true);
			await cadastraAvisos(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setTelaCadastro(false);
						buscarAvisos();
						setDadosRequestControllerRedux("Fechar Modal Avisos");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaAvisosPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarAvisos();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarAvisosPorId = async () => {
		setLoading(true);
		await getAvisosPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					if (editando) {
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarAvisosPorIdModal = async (id) => {
		setLoading(true);
		await getAvisosPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const deletarAvisosPorId = async () => {
		setLoading(true);
		await deleteAvisosPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarAvisos();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const title = useMemo(() => {
		if(editando) return "Detalhes de Avisos";
		if(telaCadastro) return "Cadastro de Avisos";
		return "Avisos";
	}, [editando, telaCadastro]);

	useEffect(() => {
		if (profile?.usuario) {
			setValues((current) => ({
				...current,
				usuario: profile?.usuario.usuario,
			}));
			setValidator((current) => ({ ...current, nome: "false" }));
		}
	}, [profile?.usuario]);

	useEffect(() => {
		if (editando) {
			buscarAvisosPorId();
		}
	}, [editando]);

	useEffect(() => {
		if (profile?.token) {
			buscarAvisos();
			if (props.idAtual) {
				buscarAvisosPorIdModal(props.idAtual);
			}
		}
	}, [profile?.token]);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Avisos"));
		}
	}, [profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<NavbarV3 title={title} selecionado="Avisos" />
			{!loading && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					{!telaCadastro && (
						<div className="embarques">
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="avisosId"
								nomeClasse1="outer-wrapper-cidade"
								nomeClasse2="table-wrapper-cidade-v2"
								colunas={dadosTabelaRedux.Avisos}
								dados={dadosTabela}
								breakTabela="table-break"
								breakTd="td-break"
							/>
							<div className="container-botoes-cliente">
								<div>
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Cadastrar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setTelaCadastro(true);
											setEditando(false);
										}}
									/>
									<CustomButtonV2
										classCss="custom-button-editar"
										classText="button-texto-editar"
										titulo="Editar"
										icone="iconeEdit"
										cor="#CDCDCD"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setTelaCadastro(true);
												setEditando(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
									<CustomButtonV2
										classCss="custom-button-deletar"
										classText="button-texto-cadastrar"
										titulo="Deletar"
										icone="iconeDelete"
										cor="#DC2D2D"
										valor={values}
										onClick={() => {
											if (tabelaRedux.colunaSelecionada) {
												setOpen(true);
												setTextoSucesso("Deletado Com Sucesso");
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								</div>
								<div>
									<CustomButtonV2
										classCss="custom-button-user"
										classText="button-texto-user"
										titulo="Obter Usuário"
										cor="#FFFFFF"
										valor={values}
										onClick={() => {
											if (tabelaRedux.usuarioAlteracao) {
												setOpenUsuario(true);
											} else {
												setTextoErro("Selecione Uma Coluna");
												setOpenToastErro(true);
											}
										}}
									/>
								</div>
							</div>
						</div>
					)}
					{telaCadastro && (
						<div>
							{!props.desabilitar && (
								<div className="indicadores">
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Dados de Avisos / "}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Avisos"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Avisos"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									<div className="close-btn">
										<CloseIcon
											onClick={() => {
												setValues({});
												setEditando(false);
												setTabelaRedux({});
											}}
										/>
									</div>
								</div>
							)}
							<div className="principal">
								<p className="input-label-emb" htmlFor="descricao">
									Mensagem:
								</p>
								<textarea
									type="text"
									className="input-emb-avisos"
									style={{ width: "100vh" }}
									rows="20"
									onChange={(e) => {
										setValues((current) => ({
											...current,
											mensagem: e.target.value,
										}));
										setValidator((current) => ({
											...current,
											mensagem: "true",
										}));
									}}
									value={values.mensagem}
								></textarea>
							</div>
							<div className="botoes-embalagem">
								{editando ? (
									<CustomButtonV2
										classCss="custom-button-cadastrar"
										classText="button-texto-cadastrar"
										icone="iconeSave"
										titulo="Salvar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											editar();
											setTelaCadastro(false);
											setEditando(false);
											setValues({});
										}}
									/>
								) : (
									<>
										{!props.desabilitar ? (
											props.botaoCadastrar ? (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														if (
															values.nome !== "" &&
															validator.mensagem === "true"
														) {
															cadastrar();
															setValues({});
														} else {
															setTextoErro("Há campos sem preencher!");
															setOpenToastErro(true);
														}
													}}
												/>
											) : (
												<CustomButtonV2
													classCss="custom-button-cadastrar"
													classText="button-texto-cadastrar"
													icone="iconeSave"
													titulo="Salvar"
													cor="#0946B8"
													valor={values}
													onClick={() => {
														if (
															values.nome !== "" &&
															validator.mensagem === "true"
														) {
															cadastrar();
															setValues({});
														} else {
															setTextoErro("Há campos sem preencher!");
															setOpenToastErro(true);
														}
													}}
												/>
											)
										) : (
											<></>
										)}
									</>
								)}
								{!props.botaoVoltar && (
									<CustomButtonV2
										classCss="custom-button-cancelar"
										classText="button-texto-cancelar"
										titulo="Cancelar"
										cor="#0946B8"
										valor={values}
										onClick={() => {
											setValues({});
											setTelaCadastro(false);
											setEditando(false);
											setTabelaRedux({});
										}}
									/>
								)}
							</div>
						</div>
					)}
					<div>
						<ModalConfirmacao
							titulo="Deletar"
							texto="Deseja Deletar?"
							tituloConfirmar="Confirmar"
							tituloCancelar="Cancelar"
							open={open}
							onClose={handleClose}
							onClick={deletarAvisosPorId}
						/>
						<ModalUsuario
							titulo="Usuário"
							tituloConfirmar="OK"
							open={openUsuario}
							onClose={handleCloseUsuario}
						/>
					</div>
					<div>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
					</div>
				</motion.div>
			)}
			{loading && <LoadingComponent />}
		</motion.div>
	);
}

export default Avisos;
